import { useCallback, useContext, useEffect, useState } from "react"
import { DateTime } from "luxon"

//SOAR components
import { LoaderMedium } from "../../../components/Loaders/index"

//SOAR Context
import { UserContext } from "../../../context/userContext"
import { LogError } from "../../../helpers/logger"

//Housing components and API
import { housingApiAssignBedOccupancyListPost } from "../housingApi"
import OccupantDetail from "./OccupantDetail"
import styles from "../../../styles/housing/HousingAllocations.module.css"
import { useField } from "formik"

export default function OccupantFormBookings({
  bedId,
  startDate,
  endDate,
  participants,
  editId,
}) {
  const userCtx = useContext(UserContext)

  const [participantIdField] = useField("participantId")
  const [, , otherOverlapHelper] = useField("overlapsOther")
  const [, , selfOverlapHelper] = useField("overlapsSelf")

  const [isLoading, setIsLoading] = useState(true)
  const [bookings, setBookings] = useState([])

  const loadBookings = useCallback(async () => {
    try {
      setIsLoading(true)

      if (!!startDate && !!endDate) {
        const startDateUtc = DateTime.fromJSDate(startDate)
          .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .toUTC()
          .toISO()

        const endDateUtc = DateTime.fromJSDate(endDate)
          .set({ hour: 23, minute: 59, second: 59, millisecond: 0 })
          .toUTC()
          .toISO()

        let listing = await housingApiAssignBedOccupancyListPost(
          userCtx.tokenHousing,
          {
            bedId,
            startDate: startDateUtc,
            endDate: endDateUtc,
            participantId: participantIdField.value,
          }
        )

        if (listing.length > 0) {
          listing.forEach((assignment) => {
            let participant = participants?.find(
              (profile) => profile.participant_id === "assignment.participantId"
            )
            assignment.participant = participant
          })

          if (!!editId) {
            listing = listing.filter((item) => item.id !== editId)
          }
        }

        setBookings(listing)
      } else {
        setBookings([])
      }

      setIsLoading(false)
    } catch (error) {
      userCtx.setNotificationError("Unable to retrieve room assignment list")
      LogError(error)
      setBookings([])
      setIsLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    startDate,
    endDate,
    userCtx.tokenHousing,
    bedId,
    participantIdField.value,
    editId,
    participants,
    userCtx.setNotificationError,
  ])

  useEffect(() => {
    otherOverlapHelper.setValue(
      bookings.some((x) => x.participantId !== participantIdField.value)
    )
    selfOverlapHelper.setValue(
      bookings.some((x) => x.participantId === participantIdField.value)
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bookings, participantIdField.value])

  useEffect(() => {
    loadBookings()
  }, [loadBookings])

  const GetAssignment = (assignment, key) => {
    const participant = participants?.find(
      (participant) => participant.participant_id === assignment.participantId
    )

    let warningText = undefined
    let useAlternateBackground = false
    if (
      !!participant &&
      participant?.participant_id === participantIdField.value
    ) {
      useAlternateBackground = true
      if (assignment.bed?.id === bedId) {
        warningText = "This participant is already assigned to this bed"
      } else {
        warningText = "This participant is assigned to another bed"
      }
    }

    return (
      <div key={key}>
        <OccupantDetail
          bedOccupancy={assignment}
          participant={participant}
          showHouse={assignment.bedId !== bedId}
          warningText={warningText}
          useAlternateBackground={useAlternateBackground}
        />
      </div>
    )
  }

  return (
    <div>
      <div className={styles.bookingsListHeader}>
        <label>Booking clashes</label>
        <div style={{ marginBottom: "10px" }}>
          <small style={{ color: "gray" }}>
            These are bookings that overlap the selected period. <br />
            If there are other participants already allocated to the room, you
            will not be able to allocate a new participant in the selected
            period
          </small>
        </div>
      </div>
      <div>
        {isLoading ? (
          <LoaderMedium />
        ) : bookings.length === 0 ? (
          <>There are no bookings in the selected period</>
        ) : (
          <>
            {bookings.map((item, index) => {
              return GetAssignment(item, index)
            })}
          </>
        )}
      </div>
    </div>
  )
}
